// ZOCO FRUITS brand mark — uses the official logo asset
// (white Arabic-inspired calligraphy on deep teal background).
// On white surfaces we show it as a small framed badge, matching
// the brand's presentation in the official deck.

const LOGO_SRC = "/brand/zoco-logo.jpg";

export const LogoMark = ({ size = 44, rounded = false, className = "" }) => (
  <div
    className={`overflow-hidden bg-[#034638] flex items-center justify-center shrink-0 ${
      rounded ? "rounded-full" : ""
    } ${className}`}
    style={{ width: size, height: size }}
    aria-hidden="true"
  >
    <img
      src={LOGO_SRC}
      alt=""
      className="w-full h-full object-cover"
      draggable={false}
    />
  </div>
);

export const LogoLockup = ({
  variant = "dark", // 'dark' = dark text on light bg, 'light' = white text
  showTagline = true,
  className = "",
  size = "md",
}) => {
  const isLight = variant === "light";
  const textColor = isLight ? "text-white" : "text-[#034638]";
  const tagColor = isLight ? "text-white/75" : "text-[#5C6E6A]";

  const wordSize =
    size === "lg"
      ? "text-4xl md:text-5xl"
      : size === "sm"
      ? "text-xl"
      : "text-3xl";
  const markSize = size === "lg" ? 64 : size === "sm" ? 32 : 44;

  return (
    <div className={`inline-flex items-center gap-3 ${className}`}>
      <LogoMark size={markSize} />
      <div className="flex flex-col leading-none">
        <span
          className={`font-display ${wordSize} ${textColor} tracking-[0.04em]`}
        >
          Zoco <span className="italic font-normal">Fruits</span>
        </span>
        {showTagline && (
          <span
            className={`font-sans-z text-[8px] md:text-[9px] tracking-[0.32em] uppercase mt-1.5 ${tagColor}`}
          >
            Fruits &amp; Vegetables Delivery
          </span>
        )}
      </div>
    </div>
  );
};

export default LogoMark;
